import { Button, Icon, IconButton, Tooltip } from "@fidelix/fx-miranda";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import styled from "styled-components";
import { useGraphicsContext } from "../graphics-context";

export function HistoryAddPreviewPointsButton() {
  const { cachedDataService } = useGraphicsContext();
  return (
    <Container>
      <TooltipContainer>
        <Tooltip
          content={
            cachedDataService?.selectionMode
              ? t`Preview on - selected points shown as line graphs`
              : t`Add points to preview to view them as line graphs`
          }
        >
          <Tooltip.Trigger>
            <Icon size={24} icon="info" />
          </Tooltip.Trigger>
        </Tooltip>
      </TooltipContainer>
      {cachedDataService?.selectionMode ? (
        <SelectionContainer>
          <Trans>
            {Object.values(cachedDataService?.getSelectedPoints()).length} in
            preview
          </Trans>
          <IconButton
            icon="close"
            variant="transparent"
            size="small"
            onPress={() => {
              cachedDataService?.resetState();
              cachedDataService?.setSelectionMode(false);
            }}
          />
        </SelectionContainer>
      ) : (
        <Button
          style={{ whiteSpace: "nowrap" }}
          variant="text"
          onPress={() => cachedDataService?.setSelectionMode(true)}
        >
          <Trans>Add points</Trans>
        </Button>
      )}
    </Container>
  );
}

const TooltipContainer = styled.div`
  margin-left: auto;
  margin-right: ${(p) => p.theme.space("xxsmall")};
  margin-top: ${(p) => p.theme.space("xxsmall")};
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

const SelectionContainer = styled(Container)`
  border: 1px solid ${(p) => p.theme.colors.lightNeutral};
  border-radius: 30px;
  background: ${(p) => p.theme.colors.extraMutedLightNeutral};
  padding: ${(p) => p.theme.space("xsmall")};
  padding-left: ${(p) => p.theme.space("medium")};
  padding-right: ${(p) => p.theme.space("medium")};
  height: 50%;
  width: 100%;
  flex-direction: row;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  height: 48px;
`;
